import { Component, Input } from '@angular/core';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { TimeMetric } from '../../../../shared/models/interfaces/dashboard/dashboard.interface';

@Component({
  selector: 'l-dashboard-time-metric-card',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './dashboard-time-metric-card.component.html',
})
export class DashboardTimeMetricCardComponent {

  @Input({ required: true })
  public metric!: TimeMetric;

}
